import React from 'react';
import cn from 'classnames';
import { getTimeInHrsMins } from '@utility/fireboardUtil';
import { formateDateInddmm } from '@utility/fireboardUtil';
import style from './slotContent.module.scss';

const SlotContent = props => {
  const { check, isAssignSlot, moveContent } = props;
  const { tabName, orderDetails, deliverTo, orders, openDate } = check || {};
  const [order0] = orders || [];
  const { pickupDate } = order0 || {};
  const pickupTime = openDate ? getTimeInHrsMins(openDate) : '';
  return (
    <>
      {isAssignSlot || moveContent ? (
        <div
          className={cn(
            'w-100 d-flex flex-column pl-2 pr-2 py-1',
            style.slotContent
          )}
        >
          <div className="d-flex row mx-0 px-0">
            <span className={cn('col-6 px-0', style.checkTruncate)}>
              {check?.checkNumber}
            </span>
            <span className="col-6 px-0 text-right">
              {orderDetails?.orderName || deliverTo}
            </span>
          </div>

          <div className="d-flex justify-content-between">
            <span>{formateDateInddmm(pickupDate)}</span>
            <span>{pickupTime}</span>
          </div>
        </div>
      ) : (
        <div className={cn('w-100 d-flex flex-column')}>
          <div>
            {check?.checkNumber}
          </div>

          <div className="d-flex justify-content-between">
            <span>{formateDateInddmm(pickupDate)}</span>
            <span>{pickupTime}</span>
          </div>
        </div>
      )}
    </>
  );
};

export default SlotContent;
